import { ReactNode } from 'react';

import { IconButton, Icons, Box, Stack, tokens } from '@cast/design-system';

type EntityListProps<T> = {
  items: T[];
  renderContent: (item: T) => ReactNode;
  showRemoveButton?: boolean;
  onRemove?: (entityId: string) => void;
};

export const EntityList = <T extends { id?: string }>({
  items,
  renderContent,
  showRemoveButton = true,
  onRemove,
}: EntityListProps<T>) => {
  return (
    <Box maxHeight="400px" overflow="auto">
      {items.map((item, index) => (
        <Stack
          key={item.id}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          py={8}
          pl={24}
          pr={16}
          borderTop={tokens.theme.border.structural.neutral}
          bgcolor={tokens.theme.bg.structural.surfaceSubtle}
          data-testid={`entity-row-${index}`}
        >
          {renderContent(item)}

          {showRemoveButton && (
            <IconButton
              variant="ghost"
              size="md"
              onClick={() => onRemove?.(item.id!)}
              testId="remove-entity-button"
            >
              <Icons.X
                fill="light"
                color={tokens.theme.fg.structural.secondary}
              />
            </IconButton>
          )}
        </Stack>
      ))}
    </Box>
  );
};
